 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-5" flat>
      <v-icon>mdi-format-align-justify</v-icon>
      <v-toolbar-title class="toolbar-title-2">{{ labels.mainTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="!hideBtns" @click.native="doNew()">
        <span>New Coins Svc Fee</span>
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-flex xs12 class="mt-2">
        <v-data-table :headers="headers" :items="itemList" :loading="loading" class="elevation-1" :no-data-text="noDataText">
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.tranTypeDocNo }}</td>
              <td>{{ row.item.riCo }}</td>
              <td>{{ row.item.acctNoSfx }}</td>
              <td>{{ formatDate(row.item.tranDate) }}</td>
              <td>{{ row.item.billCurr }}</td>
              <td>{{ formatNumber(row.item.svcFeePct, 4) }}</td>
              <td>{{ formatPrice(row.item.svcFeeAmt) }}</td>
              <td>{{ formatPrice(row.item.gstSvcFee) }}</td>
              <td>{{ formatPrice(row.item.totDue) }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  @query="doQuery(row.item)"
                  :review="canReview(row)"
                  @review="doReview(row.item)"
                  :remove="canDelete(row)"
                  @remove="doPromptRemove(row.item)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 v-if="!hideDetails">
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-3">{{ labels.title }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.tranTypeDocNo }}</v-subheader>
                  <span class="queryValue">{{ mainForm.tranTypeDocNo }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="tranTypeDocNo"
                    v-model="mainForm.tranTypeDocNo"
                    :label="labels.tranTypeDocNo"
                    :error-messages="errors.collect('tranTypeDocNo')"
                    data-vv-name="tranTypeDocNo"
                    :data-vv-as="labels.tranTypeDocNo"
                    readonly
                    :disabled="true"
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12> </v-flex>

                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.riCo }}</v-subheader>
                  <span class="queryValue">{{ mainForm.riCo }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="riCo"
                    v-model="mainForm.riCo"
                    :label="labels.riCo"
                    :error-messages="errors.collect('riCo')"
                    data-vv-name="riCo"
                    :data-vv-as="labels.riCo"
                    append-icon="mdi-magnify"
                    @click:append="riCoHelpList = true"
                    v-validate="'required'"
                    readonly
                    :disabled="disabledField"
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.riCoDesc }}</v-subheader>
                  <span class="queryValue">{{ mainForm.riCoDesc }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="riCoDesc"
                    v-model="mainForm.riCoDesc"
                    :label="labels.riCoDesc"
                    :error-messages="errors.collect('riCoDesc')"
                    data-vv-name="riCoDesc"
                    :data-vv-as="labels.riCoDesc"
                    readonly
                    :disabled="disabledField"
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
                  <span class="queryValue">{{ mainForm.acctNoSfx }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="acctNoSfx"
                    v-model="mainForm.acctNoSfx"
                    :label="labels.acctNoSfx"
                    :error-messages="errors.collect('acctNoSfx')"
                    data-vv-name="acctNoSfx"
                    :data-vv-as="labels.riCo"
                    append-icon="mdi-magnify"
                    @click:append="acctSufHelpList = true"
                    readonly
                    :disabled="disabledField"
                    :loading="loading"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.acctNoSfxDesc }}</v-subheader>
                  <span class="queryValue">{{ mainForm.acctNoSfxDesc }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="acctNoSfxDesc"
                    v-model="mainForm.acctNoSfxDesc"
                    :label="labels.acctNoSfxDesc"
                    :error-messages="errors.collect('acctNoSfxDesc')"
                    data-vv-name="acctNoSfxDesc"
                    :data-vv-as="labels.acctNoSfxDesc"
                    readonly
                    :disabled="disabledField"
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.tranDate }}</v-subheader>
                  <span class="queryValue">{{ formatDate(mainForm.tranDate) }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <cal-picker
                    ref="tranDate"
                    v-model="mainForm.tranDate"
                    :label="labels.tranDate"
                    :data-vv-as="labels.tranDate"
                    :error-messages="errors.collect('tranDate')"
                    data-vv-name="tranDate"
                    @change="getGSTRate"
                    v-validate="'required'"
                    :loading="loading"
                  ></cal-picker>
                </v-flex>
                <v-flex lg6 xs12> </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.billCurr }}</v-subheader>
                  <span class="queryValue">{{ mainForm.billCurr }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="billCurr"
                    v-model="mainForm.billCurr"
                    :label="labels.billCurr"
                    :error-messages="errors.collect('billCurr')"
                    data-vv-name="billCurr"
                    :data-vv-as="labels.billCurr"
                    append-icon="mdi-magnify"
                    @click:append="currHelpList = true"
                    v-validate="'required'"
                    readonly
                    :disabled="mainForm.billCurrRateAE === true"
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 xs1>
                  <v-checkbox
                    class="align-end justify-end"
                    color="primary"
                    v-model="mainForm.billCurrRateAE"
                    @change="getBillCurr(selectedRi)"
                    :disabled="queryMode"
                  ></v-checkbox>
                </v-flex>
                <v-flex lg5 xs11 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.billCurrRate }}</v-subheader>
                  <span class="queryValue">{{ mainForm.billCurrRate }}</span>
                </v-flex>
                <v-flex lg5 xs11 v-else>
                  <v-text-field
                    ref="billCurrRate"
                    v-model="mainForm.billCurrRate"
                    :label="labels.billCurrRate"
                    :error-messages="errors.collect('billCurrRate')"
                    data-vv-name="billCurrRate"
                    :data-vv-as="labels.billCurrRate"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 7 }"
                    v-validate="'required|mustGreaterThenZero'"
                    :loading="loading"
                    :disabled="mainForm.billCurrRateAE === true"
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.polPd }}</v-subheader>
                  <span class="queryValue">{{ mainForm.polPd }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="polPd"
                    v-model="mainForm.polPd"
                    :label="labels.polPd"
                    :error-messages="errors.collect('polPd')"
                    data-vv-name="polPd"
                    :data-vv-as="labels.polPd"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.comm }}</v-subheader>
                  <span class="queryValue">{{ mainForm.comm }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="comm"
                    v-model="mainForm.comm"
                    :label="labels.comm"
                    :error-messages="errors.collect('comm')"
                    data-vv-name="comm"
                    :data-vv-as="labels.comm"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.coinsPct }}</v-subheader>
                  <span class="queryValue">{{ mainForm.coinsPct }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="coinsPct"
                    v-model="mainForm.coinsPct"
                    :label="labels.coinsPct"
                    :error-messages="errors.collect('coinsPct')"
                    data-vv-name="coinsPct"
                    :data-vv-as="labels.coinsPct"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                    @change="getCoinsSharePremComm"
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12> </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.coinsPremDue }}</v-subheader>
                  <span class="queryValue">{{ mainForm.coinsPremDue }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="coinsPremDue"
                    v-model="mainForm.coinsPremDue"
                    :label="labels.coinsPremDue"
                    :error-messages="errors.collect('coinsPremDue')"
                    data-vv-name="coinsPremDue"
                    :data-vv-as="labels.coinsPremDue"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.coinsComm }}</v-subheader>
                  <span class="queryValue">{{ mainForm.coinsComm }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="coinsComm"
                    v-model="mainForm.coinsComm"
                    :label="labels.coinsComm"
                    :error-messages="errors.collect('coinsComm')"
                    data-vv-name="coinsComm"
                    :data-vv-as="labels.coinsComm"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.svcFeeGN }}</v-subheader>
                  <span class="queryValue">{{ filterCoinsSvcFeeGN(mainForm.svcFeeGN) }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-autocomplete
                    ref="svcFeeGN"
                    :items="coinsSvcFeeList"
                    v-model="mainForm.svcFeeGN"
                    :label="labels.svcFeeGN"
                    item-text="label"
                    item-value="value"
                    data-vv-name="mainForm.svcFeeGN"
                    :data-vv-as="labels.svcFeeGN"
                    :error-messages="errors.collect('mainForm.svcFeeGN')"
                    @change="getTotAmtChrg($event)"
                    :loading="loading"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.totAmtChrg }}</v-subheader>
                  <span class="queryValue">{{ mainForm.totAmtChrg }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="totAmtChrg"
                    v-model="mainForm.totAmtChrg"
                    :label="labels.totAmtChrg"
                    :error-messages="errors.collect('totAmtChrg')"
                    data-vv-name="totAmtChrg"
                    :data-vv-as="labels.totAmtChrg"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.svcFeePct }}</v-subheader>
                  <span class="queryValue">{{ mainForm.svcFeePct }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="svcFeePct"
                    v-model="mainForm.svcFeePct"
                    :label="labels.svcFeePct"
                    :error-messages="errors.collect('svcFeePct')"
                    data-vv-name="svcFeePct"
                    :data-vv-as="labels.svcFeePct"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
                    :loading="loading"
                    @change="getSvcFeeAmt(mainForm.svcFeeAmtAE)"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 xs1>
                  <v-checkbox
                    class="align-end justify-end"
                    color="primary"
                    v-model="mainForm.svcFeeAmtAE"
                    @change="getSvcFeeAmt($event)"
                    :disabled="queryMode"
                  ></v-checkbox>
                </v-flex>
                <v-flex lg5 xs11 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.svcFeeAmt }}</v-subheader>
                  <span class="queryValue">{{ mainForm.svcFeeAmt }}</span>
                </v-flex>
                <v-flex lg5 xs11 v-else>
                  <v-text-field
                    ref="svcFeeAmt"
                    v-model="mainForm.svcFeeAmt"
                    :label="labels.svcFeeAmt"
                    :error-messages="errors.collect('svcFeeAmt')"
                    data-vv-name="svcFeeAmt"
                    :data-vv-as="labels.svcFeeAmt"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    @change="getGstSvcFee(mainForm.gstRate)"
                    :loading="loading"
                    :disabled="mainForm.svcFeeAmtAE === true"
                  ></v-text-field>
                </v-flex>

                <v-flex lg2 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.inOutGST }}</v-subheader>
                  <span class="queryValue">{{ mainForm.inOutGST }}</span>
                </v-flex>
                <v-flex lg2 xs12 v-else>
                  <v-autocomplete
                    ref="inOutGST"
                    :items="inOutGSTList"
                    v-model="mainForm.inOutGST"
                    :label="labels.inOutGST"
                    item-text="label"
                    item-value="value"
                    data-vv-name="mainForm.inOutGST"
                    :data-vv-as="labels.inOutGST"
                    :error-messages="errors.collect('mainForm.inOutGST')"
                    :disabled="disabledField"
                    :loading="loading"
                    @change="changeCreditDebit(mainForm.inOutGST)"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg2 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.gstStat }}</v-subheader>
                  <span class="queryValue">{{ mainForm.gstStat }}</span>
                </v-flex>
                <v-flex lg2 xs12 v-else>
                  <v-text-field
                    ref="gstStat"
                    v-model="mainForm.gstStat"
                    :label="labels.gstStat"
                    :error-messages="errors.collect('gstStat')"
                    data-vv-name="gstStat"
                    :data-vv-as="labels.gstStat"
                    append-icon="mdi-magnify"
                    @click:append="gstStatHelpList = true"
                    v-validate="'required'"
                    readonly
                    :loading="loading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.gstRate }}</v-subheader>
                  <span class="queryValue">{{ mainForm.gstRate }}</span>
                </v-flex>
                <v-flex lg2 xs12 v-else>
                  <v-text-field
                    ref="gstRate"
                    v-model="mainForm.gstRate"
                    :label="labels.gstRate"
                    :error-messages="errors.collect('gstRate')"
                    data-vv-name="gstRate"
                    :data-vv-as="labels.gstRate"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.gstSvcFee }}</v-subheader>
                  <span class="queryValue">{{ mainForm.gstSvcFee }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="gstSvcFee"
                    v-model="mainForm.gstSvcFee"
                    :label="labels.gstSvcFee"
                    :error-messages="errors.collect('gstSvcFee')"
                    data-vv-name="gstSvcFee"
                    :data-vv-as="labels.gstSvcFee"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    @change="getTotDue"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 xs12> </v-flex>
                <v-flex lg6 xs12 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.totDue }}</v-subheader>
                  <span class="queryValue">{{ mainForm.totDue }}</span>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-text-field
                    ref="totDue"
                    v-model="mainForm.totDue"
                    :label="labels.totDue"
                    :error-messages="errors.collect('totDue')"
                    data-vv-name="totDue"
                    :data-vv-as="labels.totDue"
                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                    :loading="loading"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-btn color="error" dark :loading="loading" @click.prevent="doExit">
          Exit
          <v-icon dark right>mdi-exit-to-app</v-icon>
        </v-btn>
        <v-btn color="info" dark :loading="loading" v-if="!hideBtns" @click.prevent="doSaveCoinsSvcFee">
          Save
          <v-icon dark right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>
    </v-card-text>

    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected CoinsSvcFee?</p>
      <div class="queryValue">
        PolNo: {{ selectedItem.polNo }}<br />
        RenCnt: {{ selectedItem.renCnt }}<br />
        EndtCnt: {{ selectedItem.endtCnt }}<br />
        CoinsOut: {{ selectedItem.coinsOut }}<br />
        RiCo: {{ selectedItem.riCo }}<br />
        AcctNoSfx: {{ selectedItem.acctNoSfx }}<br />
        CesEndtCnt: {{ selectedItem.cesEndtCnt }}
      </div>
    </confirm>

    <v-dialog v-model="riCoHelpList" width="1000px" persistent>
      <intermediary-help-list
        :interGrps="'20'"
        @close="riCoHelpList = false"
        headerInfo="Coins / Billing Co."
        @assign-intermediary-data="doAssign($event, 'riCo')"
      />
    </v-dialog>

    <v-dialog v-model="acctSufHelpList" width="1000px" persistent>
      <acct-suf-help-list @close="acctSufHelpList = false" @assign-acct-suf-info="doAssign($event, 'acctNoSfx')" />
    </v-dialog>

    <v-dialog v-model="currHelpList" width="1000px" persistent>
      <currency-help-list @close="currHelpList = false" @assign-currency-info="doAssign($event, 'currency')" />
    </v-dialog>

    <v-dialog v-model="gstStatHelpList" width="1000px" persistent>
      <GSTStatHelpList @close="gstStatHelpList = false" @assign-gstStat="doAssign($event, 'gstStat')" />
    </v-dialog>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'
import { formatDisplayDate, removeTime } from '@/utils/date'
import clone from 'clone'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import GSTStatHelpList from '@/components/core/common/dialog/GSTStatHelpList'

export default {
  data() {
    return {
      labels: {
        mainTitle: 'Coinsurance Service Fee Details',
        title: '',
        tranTypeDocNo: 'Tran Type / Document No.',
        riCo: 'Coins / Billing Co.',
        riCoDesc: 'Coins / Billing Co. Name',
        acctNoSfx: 'Account No. Sfx',
        acctNoSfxDesc: 'Account No. Sfx Description',
        tranDate: 'Transaction Date',
        billCurr: 'Billing Currency',
        billCurrRate: 'Billing Rate',
        polPd: 'Policy Premium',
        comm: 'Policy Commission',
        coinsPct: 'Coinsurance Share %',
        coinsPremDue: 'Coinsurance Share Premium',
        coinsComm: 'Coinsurance Share Commission',
        svcFeeGN: 'Service Fee on Gross / Net',
        totAmtChrg: 'Total Amount Chargeable',
        svcFeePct: 'Service Fee %',
        svcFeeAmt: 'Service Fee Amount',
        inOutGST: 'GST I/O',
        gstStat: 'GST Stat',
        gstRate: 'GST Rate',
        gstSvcFee: 'GST Sevice Fee',
        totDue: 'Total Due'
      },
      headers: [
        { text: 'Tran Type / Doc No.', align: 'left', value: 'tranTypeDocNo' },
        { text: 'Coins Co.', value: 'riCo' },
        { text: 'AcctNoSfx', value: 'acctNoSfx' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Bill Curr', value: 'billCurr' },
        { text: 'Service Fee %', value: 'svcFeePct' },
        { text: 'Service Fee', value: 'svcFeeAmt' },
        { text: 'Service Fee GST', value: 'gstSvcFee' },
        { text: 'Total Due', value: 'totDue' },
        TableConst.tableActionHeader
      ],
      mainForm: {
        tranTypeDocNo: undefined,
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        coinsOut: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        cesEndtCnt: 0,
        tranType1: undefined,
        docNo: undefined,
        billCurr: undefined,
        billCurrRateAE: true,
        billCurrRate: 0,
        coinsPctAE: true,
        coinsPct: 0,
        svcFeeAmtAE: true,
        svcFeePct: 0,
        svcFeeAmt: 0,
        svcFeeAmtLoc: 0,
        polPd: 0,
        comm: 0,
        svcFeeGN: 'G',
        totAmtChrg: 0,
        inOutGST: undefined,
        gstStat: undefined,
        gstRate: 0,
        gstSvcFee: 0,
        gstSvcFeeLoc: 0,
        totDue: 0,
        coinsPremDue: 0,
        coinsComm: 0,
        tranDate: undefined,
        acctYr: 0,
        acctMth: 0,
        progId: undefined
      },
      itemList: [],
      loading: false,
      promptRemove: false,
      mode: 'new',
      selectedItem: {},
      hideDetails: false,
      hideBtns: false,
      disabledField: false,
      modeAction: undefined,
      coinsSvcFeeList: [
        { label: 'Gross', value: 'G' },
        { label: 'Net', value: 'N' }
      ],
      inOutGSTList: [
        { label: 'I', value: 'I' },
        { label: 'O', value: 'O' }
      ],
      riCoHelpList: false,
      acctSufHelpList: false,
      currHelpList: false,
      gstStatHelpList: false,
      newMode: false,
      reviewMode: false,
      queryMode: false
    }
  },
  beforeMount() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.mainForm.polNo = this.selectedRi.polNo
      this.mainForm.renCnt = this.selectedRi.renCnt
      this.mainForm.endtCnt = this.selectedRi.endtCnt
      this.mainForm.coinsOut = this.selectedRi.coinsOut
      this.mainForm.riCo = this.selectedRi.riCo
      this.mainForm.riCoDesc = this.selectedRi.riCoName
      this.mainForm.acctNoSfx = this.selectedRi.acctNoSfx
      this.mainForm.acctNoSfxDesc = this.selectedRi.sfxDesc
      this.mainForm.cesEndtCnt = this.selectedRi.cesEndtCnt
      this.mainForm.tranDate = new Date()
      this.mainForm.svcFeePct = formatDisplayNumber(0, 4)
      this.getCoinsSvcFeeList()
      this.getPolPdComm() // default Policy Premium & Commission
    },
    doTitle(mode) {
      if (mode === 'new') {
        this.labels.title = 'Coinsurance Service Fee (' + mode + ')'
      } else {
        this.labels.title =
          this.selectedItem.polNo +
          '/' +
          this.selectedItem.renCnt +
          '/' +
          this.selectedItem.endtCnt +
          '/' +
          this.selectedItem.coinsOut +
          '/' +
          this.selectedItem.riCo +
          '/' +
          this.selectedItem.acctNoSfx +
          '/' +
          this.selectedItem.cesEndtCnt +
          ' (' +
          mode +
          ')'
      }
    },
    changeCreditDebit(inOutGST) {
      let negateSvcFeeAmt = false
      let negateGstSvcFee = false
      let svcFeeAmt = Number(removeFormatNumber(this.mainForm.svcFeeAmt))
      let gstSvcFee = Number(removeFormatNumber(this.mainForm.gstSvcFee))
      switch (inOutGST) {
        case 'I':
          if (svcFeeAmt >= 0) {
            negateSvcFeeAmt = true
          } else {
            negateSvcFeeAmt = false
          }
          if (gstSvcFee >= 0) {
            negateGstSvcFee = true
          } else {
            negateGstSvcFee = false
          }
          break
        case 'O':
          if (svcFeeAmt < 0) {
            negateSvcFeeAmt = true
          } else {
            negateSvcFeeAmt = false
          }
          if (gstSvcFee < 0) {
            negateGstSvcFee = true
          } else {
            negateGstSvcFee = false
          }
          break
      }
      if (negateSvcFeeAmt === true) {
        this.mainForm.svcFeeAmt = formatPrice(svcFeeAmt * -1)
      } else {
        this.mainForm.svcFeeAmt = formatPrice(svcFeeAmt)
      }
      if (negateGstSvcFee === true) {
        this.mainForm.gstSvcFee = formatPrice(gstSvcFee * -1)
      } else {
        this.mainForm.gstSvcFee = formatPrice(gstSvcFee)
      }
      this.mainForm.totDue = formatPrice(Number(removeFormatNumber(this.mainForm.svcFeeAmt)) + Number(removeFormatNumber(this.mainForm.gstSvcFee)))
    },
    doHideBtns() {
      if (this.setMode !== undefined && this.setMode === 'query') {
        this.hideBtns = true
      } else if (this.setMode === 'review' && this.mode === 'query') {
        this.hideBtns = true
      } else {
        this.hideBtns = false
      }
    },
    async getCoinsSvcFeeList() {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.coinsSvcFeeList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.selectedRi.polNo,
            renCnt: this.selectedRi.renCnt,
            endtCnt: this.selectedRi.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.itemList = []
            data.data.map((item) => {
              const convertList = {
                key: item.polNo + item.renCnt + item.endtCnt + item.coinsOut + item.riCo + item.acctNoSfx + item.cesEndtCnt,
                tranTypeDocNo: item.tranType1 === null && item.docNo === null ? '-' : item.tranType1 + item.docNo,
                polNo: item.polNo,
                renCnt: item.renCnt,
                endtCnt: item.endtCnt,
                coinsOut: item.coinsOut,
                riCo: item.riCo,
                acctNoSfx: item.acctNoSfx,
                cesEndtCnt: item.cesEndtCnt,
                tranDate: item.tranDate,
                billCurr: item.billCurr,
                svcFeePct: item.svcFeePct,
                svcFeeAmt: item.svcFeeAmt,
                gstSvcFee: item.gstSvcFee,
                totDue: item.svcFeeAmt + item.gstSvcFee
              }
              this.itemList.push(convertList)
            })
            if (this.itemList.length > 0) {
              this.selectedItem = this.itemList[this.itemList.length - 1]
              this.doTitle(this.setMode)
              this.doMode(this.setMode)
              this.doReview(this.selectedItem)
            } else {
              this.doTitle(this.setMode === 'query' ? 'query' : 'new')
              this.doMode(this.setMode === 'query' ? 'query' : 'new')
              this.mode = 'new'
              this.doResetMainForm()
              if (this.setMode === 'query') {
                this.mode = 'query'
                this.hideDetails = true
              } else {
                this.hideDetails = false
              }
              this.doHideBtns()
            }
            this.loading = false
          } else {
            this.loading = false
            this.itemList = []
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getTop1RiOutMaster() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.getTop1RiOutMaster
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.mainForm.riCo = data.riCo
            this.mainForm.riCoDesc = data.interName
            this.mainForm.acctNoSfx = data.acctNoSfx
            this.mainForm.acctNoSfxDesc = data.sfxDesc
            this.getDisabledField(true)
          } else {
            this.getDisabledField(false)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async getCoinsShareValue() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.getCoinsShare
      if (apiURI) {
        this.loading = true
        const expand = {
          polNo: this.selectedRi.polNo,
          renCnt: this.selectedRi.renCnt,
          endtCnt: this.selectedRi.endtCnt
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.mainForm.coinsPct = formatDisplayNumber(data.riOutRiskPrem.riSIPct, 6)
            } else {
              this.mainForm.coinsPct = formatDisplayNumber(0, 6)
            }
            this.getCoinsSharePremComm()
            this.loading = false
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          })
      }
    },
    async doSaveCoinsSvcFee() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.getGSTRate().then((result2) => {
            if (result2) {
              if (this.mode === 'new') {
                this.doCreate()
              } else if (this.mode === 'review') {
                this.doUpdate()
              }
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      this.loading = true
      let cMainForm = clone(this.mainForm)
      if (cMainForm.inOutGST === 'I') {
        cMainForm.coinsOut = false
      } else {
        cMainForm.coinsOut = true
      }
      cMainForm.dept = this.selectedRi.dept
      if (cMainForm.svcFeeGN === 'G') {
        cMainForm.svcFeeGN = true
      } else {
        cMainForm.svcFeeGN = false
      }
      let bc = cMainForm.billCurr.split(' - ')
      cMainForm.billCurr = bc[0]
      cMainForm.billCurrRate = removeFormatNumber(cMainForm.billCurrRate)
      cMainForm.coinsPct = removeFormatNumber(cMainForm.coinsPct)
      cMainForm.svcFeePct = removeFormatNumber(cMainForm.svcFeePct)
      cMainForm.svcFeeAmt = removeFormatNumber(cMainForm.svcFeeAmt)
      cMainForm.gstRate = removeFormatNumber(cMainForm.gstRate)
      cMainForm.gstSvcFee = removeFormatNumber(cMainForm.gstSvcFee)
      cMainForm.coinsPremDue = removeFormatNumber(cMainForm.coinsPremDue)
      cMainForm.coinsComm = removeFormatNumber(cMainForm.coinsComm)
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.createCoinsSvcFee
      if (apiURI) {
        this.$http
          .post(apiURI, cMainForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.getCoinsSvcFeeList()
            }
            this.loading = false
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.loading = false
          })
      }
    },
    doUpdate() {
      this.loading = true
      let cMainForm = clone(this.mainForm)
      if (cMainForm.inOutGST === 'I') {
        cMainForm.coinsOut = false
      } else {
        cMainForm.coinsOut = true
      }
      cMainForm.dept = this.selectedRi.dept
      if (cMainForm.svcFeeGN === 'G') {
        cMainForm.svcFeeGN = true
      } else {
        cMainForm.svcFeeGN = false
      }
      let bc = cMainForm.billCurr.split(' - ')
      cMainForm.billCurr = bc[0]
      cMainForm.billCurrRate = removeFormatNumber(cMainForm.billCurrRate)
      cMainForm.coinsPct = removeFormatNumber(cMainForm.coinsPct)
      cMainForm.svcFeePct = removeFormatNumber(cMainForm.svcFeePct)
      cMainForm.svcFeeAmt = removeFormatNumber(cMainForm.svcFeeAmt)
      cMainForm.gstRate = removeFormatNumber(cMainForm.gstRate)
      cMainForm.gstSvcFee = removeFormatNumber(cMainForm.gstSvcFee)
      cMainForm.coinsPremDue = removeFormatNumber(cMainForm.coinsPremDue)
      cMainForm.coinsComm = removeFormatNumber(cMainForm.coinsComm)
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.updateCoinsSvcFee
      if (apiURI) {
        this.$http
          .put(apiURI, cMainForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.getCoinsSvcFeeList()
            }
            this.loading = false
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.loading = false
          })
      }
    },
    doPromptRemove(item) {
      this.selectedItem = item
      this.promptRemove = true
    },
    async doDelete() {
      this.doDeleteDetails().then((result) => {
        this.promptRemove = false
        if (result) {
          this.getCoinsSvcFeeList()
        }
      })
    },
    async doDeleteDetails() {
      if (this.selectedItem) {
        const apiURI = this.$store.state.reinsurance.riOutListing.menu.deleteCoinsSvcFee
        if (apiURI) {
          await this.$http
            .post(apiURI, this.selectedItem)
            .then((result) => {
              const data = result.data
              this.notify(data)
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              return false
            })
          return true
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          return false
        }
      }
    },
    doAssign(data, field) {
      switch (field) {
        case 'riCo':
          this.mainForm.riCo = data.inter
          this.mainForm.riCoDesc = data.name
          this.riCoHelpList = false
          break
        case 'acctNoSfx':
          this.mainForm.acctNoSfx = data.acctNoSfx
          this.mainForm.acctNoSfxDesc = data.description
          this.acctSufHelpList = false
          break
        case 'currency':
          this.mainForm.billCurr = data.curr + ' - ' + data.currDesc
          this.mainForm.billCurrRate = formatDisplayNumber(data.currRate, 7)
          this.currHelpList = false
          break
        case 'gstStat':
          this.mainForm.gstStat = data
          this.getGSTRate()
          this.gstStatHelpList = false
          break
      }
    },
    doResetMainForm() {
      this.mainForm.tranTypeDocNo = undefined
      this.mainForm.polNo = this.selectedRi.polNo
      this.mainForm.renCnt = this.selectedRi.renCnt
      this.mainForm.endtCnt = this.selectedRi.endtCnt
      this.mainForm.riCo = undefined
      this.mainForm.riCoDesc = undefined
      this.mainForm.acctNoSfx = undefined
      this.mainForm.acctNoSfxDesc = undefined
      this.mainForm.cesEndtCnt = 0
      this.mainForm.tranType1 = undefined
      this.mainForm.docNo = undefined
      this.mainForm.billCurr = undefined
      this.mainForm.billCurrRateAE = true
      this.mainForm.billCurrRate = 0
      this.mainForm.coinsPctAE = true
      this.mainForm.coinsPct = formatDisplayNumber(0, 6)
      this.mainForm.svcFeeAmtAE = true
      this.mainForm.svcFeePct = formatDisplayNumber(0, 4)
      this.mainForm.svcFeeAmt = 0
      this.mainForm.svcFeeAmtLoc = 0
      this.mainForm.polPd = 0
      this.mainForm.comm = 0
      this.mainForm.svcFeeGN = 'G'
      this.mainForm.totAmtChrg = 0
      this.mainForm.inOutGST = undefined
      this.mainForm.gstStat = undefined
      this.mainForm.gstRate = formatDisplayNumber(0, 4)
      this.mainForm.gstSvcFee = 0
      this.mainForm.gstSvcFeeLoc = 0
      this.mainForm.totDue = 0
      this.mainForm.coinsPremDue = 0
      this.mainForm.coinsComm = 0
      this.mainForm.tranDate = new Date()
      this.mainForm.acctYr = 0
      this.mainForm.acctMth = 0
      this.mainForm.progId = undefined
      this.doFunction()
    },
    doFunction() {
      this.getPolPdComm() // default Policy Premium & Commission
      this.getTop1RiOutMaster() // default riCo & acctNoSfx
      this.getBillCurr(this.selectedRi) // default Bill Currency
      this.getCoinsShare() // default Coinsurance Share %
      this.getInOutGST() // default In Out GST
    },
    doMode(mode) {
      if (mode === 'new') {
        this.newMode = true
        this.reviewMode = false
        this.queryMode = false
      } else if (mode === 'review') {
        this.newMode = false
        this.reviewMode = true
        this.queryMode = false
      } else {
        this.newMode = false
        this.reviewMode = false
        this.queryMode = true
      }
    },
    doActionMode(mode) {
      if (mode === 'new') {
        this.modeAction = 'createCoinsSvcFee'
      } else if (mode === 'edit') {
        this.modeAction = 'updateCoinsSvcFee'
      }
    },
    doNew() {
      this.mode = 'new'
      this.doTitle('new')
      this.doMode('new')
      this.doResetMainForm()
      this.doHideBtns()
    },
    doQuery(item) {
      this.mode = 'query'
      this.selectedItem = item
      this.doReviewDetails('query')
      this.doHideBtns()
    },
    doReview(item) {
      this.mode = 'review'
      this.selectedItem = item
      this.doReviewDetails(this.setMode)
      this.doHideBtns()
    },
    doReviewDetails(mode) {
      if (this.selectedItem) {
        this.doTitle(mode)
        this.doMode(mode)
        this.doActionMode(mode)
        const apiURI = this.$store.state.reinsurance.riOutListing.menu.getCoinsSvcFee
        let cMainForm = clone(this.mainForm)
        cMainForm.polNo = this.selectedItem.polNo
        cMainForm.renCnt = this.selectedItem.renCnt
        cMainForm.endtCnt = this.selectedItem.endtCnt
        cMainForm.coinsOut = this.selectedItem.coinsOut
        cMainForm.riCo = this.selectedItem.riCo
        cMainForm.acctNoSfx = this.selectedItem.acctNoSfx
        cMainForm.cesEndtCnt = this.selectedItem.cesEndtCnt
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, cMainForm))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.mainForm.riCo = data.coinsSvcFee.riCo
                this.mainForm.riCoDesc = data.coinsSvcFee.riCoDesc
                this.mainForm.acctNoSfx = data.coinsSvcFee.acctNoSfx
                this.mainForm.acctNoSfxDesc = data.coinsSvcFee.acctNoSfxDesc
                this.mainForm.dept = data.coinsSvcFee.dept
                this.mainForm.tranTypeDocNo =
                  data.coinsSvcFee.tranType1 === null && data.coinsSvcFee.docNo === null ? '' : data.coinsSvcFee.tranType1 + data.coinsSvcFee.docNo
                this.mainForm.tranType1 = data.coinsSvcFee.tranType1
                this.mainForm.docNo = data.coinsSvcFee.docNo
                this.mainForm.billCurrRateAE = data.coinsSvcFee.billCurrRateAE
                this.getBillCurr(data.coinsSvcFee)
                this.mainForm.coinsPctAE = data.coinsSvcFee.coinsPctAE
                this.mainForm.coinsPct = formatDisplayNumber(data.coinsSvcFee.coinsPct, 6)
                this.mainForm.svcFeeAmtAE = data.coinsSvcFee.svcFeeAmtAE
                this.mainForm.svcFeePct = formatDisplayNumber(data.coinsSvcFee.svcFeePct, 4)
                this.mainForm.svcFeeAmt = formatPrice(data.coinsSvcFee.svcFeeAmt)
                this.mainForm.svcFeeAmtLoc = formatPrice(data.coinsSvcFee.svcFeeAmtLoc)
                if (data.coinsSvcFee.svcFeeGN) {
                  this.mainForm.svcFeeGN = 'G'
                } else {
                  this.mainForm.svcFeeGN = 'N'
                }
                this.mainForm.inOutGST = data.coinsSvcFee.inOutGST
                this.mainForm.gstStat = data.coinsSvcFee.gstStat
                this.mainForm.gstRate = formatDisplayNumber(data.coinsSvcFee.gstRate, 4)
                this.mainForm.gstSvcFee = formatPrice(data.coinsSvcFee.gstSvcFee)
                this.mainForm.gstSvcFeeLoc = formatPrice(data.coinsSvcFee.gstSvcFeeLoc)
                this.mainForm.coinsPremDue = formatPrice(data.coinsSvcFee.coinsPremDue)
                this.mainForm.coinsComm = formatPrice(data.coinsSvcFee.coinsComm)
                this.mainForm.tranDate = data.coinsSvcFee.tranDate
                this.mainForm.acctYr = data.coinsSvcFee.acctYr
                this.mainForm.acctMth = data.coinsSvcFee.acctMth
                this.mainForm.progId = data.coinsSvcFee.progId
                this.getCoinsSharePremComm()
                this.getTotDue()
                this.getDisabledField(true)
              } else {
                this.getDisabledField(false)
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    getDisabledField(value) {
      if (
        this.selectedRi.billCoIns === 'Y' ||
        this.polMaster.billCoIns === 'N' ||
        this.selectedRi.billCoIns === undefined ||
        this.selectedRi.billCoIns === null ||
        this.selectedRi.billCoIns === ''
      ) {
        if (value) {
          this.disabledField = true
        } else {
          this.disabledField = false
        }
      } else {
        this.disabledField = false
      }
    },
    getPolPdComm() {
      if (this.selectedRi.dri) {
        if (this.selectedRi.billCoIns === 'N') {
          this.mainForm.polPd = formatPrice((this.selectedRi.polPd * 100) / (100 - this.selectedRi.coInsPct))
          this.mainForm.comm = formatPrice(
            (((this.selectedRi.comm1 + this.selectedRi.comm2 + this.selectedRi.comm3 + this.selectedRi.disc) * 100) / (100 - this.selectedRi.coInsPct) * -1)
          )
        } else if (this.polMaster.billCoIns === 'Y') {
          this.mainForm.polPd = formatPrice(this.selectedRi.polPd)
          this.mainForm.comm = formatPrice((this.selectedRi.comm1 + this.selectedRi.comm2 + this.selectedRi.comm3 + this.selectedRi.disc) * -1)
        }
      } else if (!this.selectedRi.dri) {
        this.mainForm.polPd = formatPrice(this.selectedRi.polPd)
        this.mainForm.comm = formatPrice((this.selectedRi.comm1 + this.selectedRi.comm2 + this.selectedRi.comm3 + this.selectedRi.disc) * -1)
      } else {
        this.mainForm.polPd = formatPrice(0)
        this.mainForm.comm = formatPrice(0)
      }
      this.getCoinsSharePremComm()
    },
    getBillCurr(data) {
      this.mainForm.billCurr = data.billCurr
      this.mainForm.billCurrRate = formatDisplayNumber(data.billCurrRate, 7)
    },
    getCoinsShare() {
      if (this.selectedRi.dri) {
        if (this.selectedRi.billCoIns === 'N') {
          this.mainForm.coinsPct = formatDisplayNumber(100 - this.selectedRi.coInsPct, 6)
        } else if (this.selectedRi.billCoIns === 'Y') {
          this.mainForm.coinsPct = formatDisplayNumber(this.selectedRi.coInsPct, 6)
        } else {
          this.mainForm.coinsPct = formatDisplayNumber(100, 6)
        }
        this.getCoinsSharePremComm()
      } else {
        this.getCoinsShareValue()
      }
    },
    getCoinsSharePremComm() {
      let polPd = Number(removeFormatNumber(this.mainForm.polPd))
      let comm = Number(removeFormatNumber(this.mainForm.comm))
      let coinsPct = Number(removeFormatNumber(this.mainForm.coinsPct))
      this.mainForm.coinsPremDue = formatPrice((polPd * coinsPct) / 100)
      this.mainForm.coinsComm = formatPrice((comm * coinsPct) / 100)
      this.getTotAmtChrg(this.mainForm.svcFeeGN)
    },
    getTotAmtChrg(svcFeeGN) {
      if (svcFeeGN === 'G') {
        this.mainForm.totAmtChrg = this.mainForm.coinsPremDue
      } else {
        let coinsPremDue = Number(removeFormatNumber(this.mainForm.coinsPremDue))
        let coinsComm = Number(removeFormatNumber(this.mainForm.coinsComm))
        this.mainForm.totAmtChrg = formatPrice(coinsPremDue + coinsComm)
      }
      this.getSvcFeeAmt(this.mainForm.svcFeeAmtAE)
    },
    getSvcFeeAmt(svcFeeAmtAE) {
      if (svcFeeAmtAE) {
        let totAmtChrg = Number(removeFormatNumber(this.mainForm.totAmtChrg))
        let svcFeePct = Number(removeFormatNumber(this.mainForm.svcFeePct))
        let billCurrRate = Number(removeFormatNumber(this.mainForm.billCurrRate))
        this.mainForm.svcFeeAmt = formatPrice((((totAmtChrg * svcFeePct) / 100) * billCurrRate) * -1)
        let svcFeeAmt = Number(removeFormatNumber(this.mainForm.svcFeeAmt))
        this.mainForm.svcFeeAmtLoc = svcFeeAmt * billCurrRate
        let gstRate = Number(removeFormatNumber(this.mainForm.gstRate))
        this.getGstSvcFee(gstRate)
        this.getTotDue()
      }
    },
    getGstSvcFee(gstRate) {
      let svcFeeAmt = Number(removeFormatNumber(this.mainForm.svcFeeAmt))
      this.mainForm.gstSvcFee = formatPrice(((svcFeeAmt * gstRate) / 100).toFixed(2))
      let gstSvcFee = Number(removeFormatNumber(this.mainForm.gstSvcFee))
      let billCurrRate = Number(removeFormatNumber(this.mainForm.billCurrRate))
      this.mainForm.gstSvcFeeLoc = gstSvcFee * billCurrRate
      this.getTotDue()
    },
    getTotDue() {
      let svcFeeAmt = Number(removeFormatNumber(this.mainForm.svcFeeAmt))
      let gstSvcFee = Number(removeFormatNumber(this.mainForm.gstSvcFee))
      this.mainForm.totDue = formatPrice(svcFeeAmt + gstSvcFee)
      this.changeCreditDebit(this.mainForm.inOutGST)
    },
    getInOutGST() {
      if (this.polMaster.appCoIns) {
        // if (
        //   this.polMaster.billCoIns === 'N' ||
        //   this.polMaster.billCoIns === '' ||
        //   this.polMaster.billCoIns === undefined ||
        //   this.polMaster.billCoIns === null
        // ) {
        //   this.mainForm.inOutGST = 'I'
        // } else {
        //   this.mainForm.inOutGST = 'O'
        // }
        if (this.polMaster.billCoIns === 'N' || this.polMaster.billCoIns === 'Y') {
          this.mainForm.inOutGST = 'O'
        } else {
          this.mainForm.inOutGST = 'I'
        }
      }
    },
    async getGSTRate() {
      if ((this.mainForm.gstStat !== undefined || this.mainForm.gstStat !== '') && this.mainForm.tranDate !== undefined) {
        const apiURI = this.$store.state.reinsurance.riOutListing.menu.getGSTRate
        if (apiURI) {
          try {
            const expand = {
              gstStat: this.mainForm.gstStat,
              tranDate: removeTime(this.mainForm.tranDate)
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.getGstSvcFee(data.gstRate)
              this.mainForm.gstRate = formatDisplayNumber(data.gstRate, 4)
            }
            return true
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.$toast.error(data.messages[0].message)
            }
            return false
          }
        }
      } else {
        this.$toast.error('Please enter GSTStat value and TranDate value.')
      }
    },
    doExit() {
      this.$emit('close')
    },
    canReview(data) {
      return this.setMode === 'review'
    },
    canDelete(data) {
      return this.setMode === 'review'
    },
    filterCoinsSvcFeeGN(val) {
      for (let coinsSvcFee of this.coinsSvcFeeList) {
        if (coinsSvcFee.value === val) {
          return coinsSvcFee.label
        }
      }
      return ''
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatNumber(xValue, xDecimal) {
      if (xValue === null) {
        return undefined
      } else {
        return formatDisplayNumber(xValue, xDecimal)
      }
    },
    formatPrice(xValue) {
      if (xValue === null) {
        return undefined
      } else {
        return formatPrice(xValue)
      }
    }
  },
  created() {
    const mustGreaterThenZero = {
      getMessage: (field, args) => {
        return field + ' cannot be 0'
      },
      validate: (value, args) => {
        return removeFormatNumber(value) >= 0.000001
      }
    }

    this.$validator.extend('mustGreaterThenZero', mustGreaterThenZero)
  },
  props: {
    selectedRi: {
      type: Object,
      default: null
    },
    setMode: {
      type: String,
      default: undefined
    }
  },
  components: {
    IntermediaryHelpList,
    AcctSufHelpList,
    CurrencyHelpList,
    GSTStatHelpList
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
